import { ttFirsNeue } from "@/fonts"
import LargeArrowRight from "@/icons/largearrowright"
import { cn } from "@/lib/utils"
import Image from "next/image"
import React from "react"

type Props = {
  src: string
  name: string
  position: string
  desc?: string
}

const TeamCardV2 = ({ src, name, position, desc }: Props) => {
  return (
    <div className="bg-[#262626] md:rounded-[50px] rounded-[20px] flex flex-col gap-12 py-6 px-4 md:px-6 xl:px-8 border border-[#262626] hover:border-[#64B7B3] hover:bg-woodsmoke transition duration-500 ease-in-out">
      <div className="w-[85px] md:w-[100px] xl:w-[120px] xl:h-[120px] md:h-[100px] h-[85px] rounded-full bg-[#64B7B3] mx-auto">
        <Image
          src={src}
          alt={name}
          width={60}
          height={60}
          className="object-cover rounded-full w-full h-full"
        />
      </div>
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <div
            className={cn(
              "text-2xl md:text-xl xl:text-[30px] font-medium leading-4 xl:whitespace-nowrap",
              ttFirsNeue.className
            )}
          >
            {name}
          </div>
          <div className="text-[10px] md:text-xs xl:text-sm font-medium uppercase leading-3">
            {position}
          </div>
        </div>
        <LargeArrowRight />
      </div>
    </div>
  )
}

export default TeamCardV2
